export const FACEBOOK_SCOPES = [
    "pages_messaging",
    "pages_show_list",
    "pages_read_user_content",
    "publish_video",
    "pages_read_engagement",
    "pages_manage_posts",
    "pages_manage_metadata",
    "business_management"
];

export const INSTAGRAM_SCOPES = [
    ...FACEBOOK_SCOPES,
    "instagram_basic",
    "instagram_content_publish"
];

interface FacebookAuthUrlArgs {
    state: object;
    clientId: string;
    redirectUri: string;
    scopes: string[];
    configId?: string;
    reauthenticate?: boolean;
}

export function buildFacebookAuthUrl({
    state,
    clientId,
    redirectUri,
    scopes,
    configId,
    reauthenticate
}: FacebookAuthUrlArgs): URL {
    const authURL = new URL(`https://www.facebook.com/v22.0/dialog/oauth`);

    authURL.searchParams.append("state", JSON.stringify(state));
    authURL.searchParams.append("default_audience", "everyone");
    authURL.searchParams.append("client_id", clientId);
    if (configId) {
        authURL.searchParams.append("config_id", configId);
    } else {
        authURL.searchParams.append("scope", scopes.join(","));
    }
    authURL.searchParams.append("redirect_uri", redirectUri);

    if (reauthenticate) {
        authURL.searchParams.append("auth_type", "reauthenticate");
    }

    return authURL;
}

export function getFacebookScopes(instagramEnabled: boolean): string[] {
    return instagramEnabled ? INSTAGRAM_SCOPES : FACEBOOK_SCOPES;
}
